/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Medialibrarydetailsdescription3Inputs */

const en_medialibrarydetailsdescription3 = /** @type {(inputs: Medialibrarydetailsdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview and details for this asset`)
};

const de_medialibrarydetailsdescription3 = /** @type {(inputs: Medialibrarydetailsdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorschau und Infos zu diesem Inhalt`)
};

/**
* | output |
* | --- |
* | "Preview and details for this asset" |
*
* @param {Medialibrarydetailsdescription3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const medialibrarydetailsdescription3 = /** @type {((inputs?: Medialibrarydetailsdescription3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Medialibrarydetailsdescription3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_medialibrarydetailsdescription3(inputs)
	return de_medialibrarydetailsdescription3(inputs)
});
export { medialibrarydetailsdescription3 as "mediaLibraryDetailsDescription" }